import React, { useEffect } from 'react'
import css from './ListPLTS.module.scss'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from "react-hook-form";
import { CheckPLTS, CreatePLTS } from '../../../Services/Admin/PLTS'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CreatePLTSPage = () => {
    const {register, handleSubmit, setValue, formState: { errors }, reset} = useForm();
    const navigate = useNavigate();
    const [GridDate, setGridDate] = useState();
    const [StartDate, setStartDate] = useState();
    const [StatusMessageError, setMessageError] = useState(false);
    const [StatusMessageSuccess, setMessageSuccess] = useState(false);
    const [StatusCheckPLTS, setCheckPLTS] = useState(false);
    const [buttonClicked, setButtonClicked] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);

    
    const hideModal = () => {
        reset();
        setIsSuccess(false)
        setCheckPLTS(false)
        setGridDate(null)
        setMessageError(null)
        setMessageSuccess(null)
        setStartDate(null)
    };

    const handleDeleteConfirm = () => {
        alert("Delete confirmed");
        hideModal();
    };

    const onChangeStationCode = (e) => {
        if(e.target.value.length == 11){
            var data = new FormData();
            data.append("stationCode", e.target.value);

            CheckPLTS(data).then((result) => {
                setCheckPLTS(true)
                setMessageSuccess('Station Available')
                setMessageError(null)

                setValue('powerKwp',(result.data.capacity*1000))
                setValue('stationCode',result.data.stationCode)
                setValue('stationName',result.data.stationName)
                setValue('stationAddress',result.data.stationAddr)
                setValue('location',result.data.stationAddr)
                setValue('latitude',result.data.latitude)
                setValue('longitude',result.data.longitude)
            }).catch(({ response }) => {
                if(response.data.message == 'Station not found'){
                    setCheckPLTS(false)
                    setMessageError(response.data.message)
                }
                setMessageSuccess(null)

                if(response.status === 401){
                    console.log(response)
                }
            });
        }else{
            setMessageError('Please enter valid station code')
            setMessageSuccess(null)
            setCheckPLTS(false)

        }
    }

    function onUpdate(data) {

        if(buttonClicked == 'save'){
            CreatePLTS(data).then((result) => {
                setIsSuccess(true)
            }).catch(({ response }) => {
                setIsError(true)
            });
        }
    }

    useEffect(() => {
        setValue('country', 'Indonesia')
        setValue('serviceProvider', 'Modena')
    }, [])
    
    useEffect(() => {
        if(GridDate){
            const dateGrid = new Date(GridDate);

            const formattedDateGrid = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            day: '2-digit',
            month: '2-digit'
            }).format(dateGrid);

            
            const dateStart = new Date(GridDate);

            const formattedDateStart = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            day: '2-digit',
            month: '2-digit',
            }).format(dateStart);
            
            setValue('gridConnectionDate', formattedDateGrid)
            setValue('startDateSafeRunning', formattedDateStart)
        }
    }, [StartDate, GridDate])

    return (
    <div className='wrap_admin'>
        
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been created. </p>
                </div> 
            </div>
        }

        
        {isError && 
            <div className={css.popup_wrap} onClick={()=> setIsError(false)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=> setIsError(false)}></i>
                    <img src="/monitoring/assets/error.png" />
                    <b>Error!</b>
                    <p>Station code already exists. </p>
                </div> 
            </div>
        }

        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onUpdate)}>
                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Station Code</label>
                                <input type='text' placeholder='Find Station Code...' onChange={onChangeStationCode} maxLength={11} />
                                {StatusMessageError && <p style={{color:'red'}}>{StatusMessageError}</p>}
                                {StatusMessageSuccess && <p style={{color:'green'}}>{StatusMessageSuccess}</p>}

                                <label>Country/Region</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}>
                                    <option value={'Indonesia'} selected>Indonesia</option>
                                </select>
                                
                                <label>Service Provider</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}>
                                    <option value={'Modena'}>Modena</option>
                                </select>

                                <label>Station Type</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("stationType", { 
                                        required: "This field is required"
                                    })}
                                >
                                    <option>Select Type</option>
                                    <option value={'Residential'}>Residential</option>
                                    <option value={'Business'}>Business</option>
                                </select>
                                {errors.stationType && <p style={{color:'red'}}>{errors.stationType.message}</p>}
                                
                            </div>
                            <div className='col-md-6'>
                                <label>Grid Connection Date</label>
                                <DatePicker selected={StartDate} onChange={(date) => setStartDate(date)} disabled={StatusCheckPLTS == false ? true : false} placeholderText="Select a date"/>
                                
                                <label>Start Date of Safe Running</label>
                                <DatePicker selected={GridDate} onChange={(date) => setGridDate(date)} disabled={StatusCheckPLTS == false ? true : false} placeholderText="Select a date"/>
                                
                                
                                <label>API Group</label>
                                <select disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("groupId", { 
                                        required: "This field is required"
                                    })}
                                >
                                    <option value={''}>Select Group</option>
                                    <option value={1}>Group 1</option>
                                    <option value={2}>Group 2</option>
                                    <option value={3}>Group 3</option>
                                    <option value={4}>Group 4</option>
                                </select>
                                {errors.groupId && <p style={{color:'red'}}>{errors.groupId.message}</p>}

                                <label>EV Charger Only Plant</label>
                                <input type='text' placeholder='Add EV Charger Only Plant'  disabled={StatusCheckPLTS == false ? true : false}
                                    {...register("ev", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.ev && <p style={{color:'red'}}>{errors.ev.message}</p>}

                                
                                
                            </div>
                        </div>
                        

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                {/* <button className='admin-button delete' onClick={() => setButtonClicked('delete')}>Delete</button> */}
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')} disabled={StatusCheckPLTS == false ? true : false} >Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreatePLTSPage